module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHN0eWxlPSJiYWNrZ3JvdW5kLWNvbG9yOiB0cmFuc3BhcmVudCIgdmlld0JveD0iMCAwIDMwIDMwIj4gPCEtLSBjaGFuZ2UgYmFja2dyb3VuZC1jb2xvciB0byB3aGl0ZSBpZiB5b3Ugd2FudCAhLS0+DQogIDxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPg0KICAgIDxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+DQogICAgICA8cG9seWdvbiBwb2ludHM9IjUgNSAyNCAxNSA1IDI1IDUgNSIgdmVjdG9yLWVmZmVjdD0ibm9uLXNjYWxpbmctc3Ryb2tlIiBzdHlsZT0iZmlsbDogbm9uZTsgc3Ryb2tlOiB3aGl0ZTsiIHN0cm9rZS13aWR0aD0iMiIgLz4NCiAgICA8L2c+DQogIDwvZz4NCjwvc3ZnPg0KDQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/simpleplayer/images/play_scalable.svg
// module id = DKVC
// module chunks = 1